// Selectors for both desktop and mobile Table of Contents
const tableOfContentsMobile = document.querySelector('.tableOfContentsMobile');
const tableOfContentsMobileLabel = document.querySelector('.tableOfContentsMobile label');
const tableOfContentsDesktop = document.querySelector('.tableOfContentsDesktop'); // Desktop version

// Mobile-specific toggle functionality
if (tableOfContentsMobile && tableOfContentsMobileLabel) {
    tableOfContentsMobileLabel.addEventListener("click", function () {
        const contentList = tableOfContentsMobile.querySelector('ul');

        if (contentList) {
            // Toggle the class to show/hide the <ul>
            contentList.classList.toggle('open');
            tableOfContentsMobileLabel.classList.toggle('rotate');
        }
    });

    window.addEventListener('scroll', function () {
        // Check how far the page has been scrolled
        const scrollY = window.scrollY;

        // Change the top position based on scroll position
        if (scrollY > 80) { // When the scroll position is more than 80px
            tableOfContentsMobile.style.top = '0'; // Fixed position at the top of the viewport
        } else {
            tableOfContentsMobile.style.top = '5rem'; // Header height
        }
    });
}

// Common function for smooth scrolling on both desktop and mobile
function addSmoothScroll(tocElement) {
    const tocLinks = tocElement.querySelectorAll('a');
    const offset = tableOfContentsMobileLabel ? tableOfContentsMobileLabel.offsetHeight + 80 : 0; // Adjust based on mobile label height

    tocLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default anchor link behavior

            // Get the target section id from the clicked link's href attribute
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Calculate the scroll position, accounting for offset
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

                // Smoothly scroll to the target section
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });

                // For mobile: close the menu after clicking
                if (tocElement === tableOfContentsMobile) {
                    const contentList = tableOfContentsMobile.querySelector('ul');
                    if (contentList) {
                        contentList.classList.remove('open');
                        tableOfContentsMobileLabel.classList.remove('rotate');
                    }
                }
            }
        });
    });
}

// Add smooth scrolling to both desktop and mobile Table of Contents
if (tableOfContentsMobile) addSmoothScroll(tableOfContentsMobile);
if (tableOfContentsDesktop) addSmoothScroll(tableOfContentsDesktop);
